  /**
   * Methods
   */
  /**
   * Format double braced template string
   * @param {string} string
   * @param {string} find
   * @param {any} replace
   * @returns {string}
  */
  export const findReplaceString = (string: string, find: string, replace: any): any => {
    // Find and replace double curly braces, example: findReplace("Hello, {{ name }}", "name", "John"); // "Hello, John"
    if ((/[a-zA-Z\_]+/g).test(string)) {
        return string.replace(new RegExp('\{\{(?:\\s+)?(' + find + ')(?:\\s+)?\}\}'), replace);
    } else {
        throw new Error('Find statement does not match regular expression: /[a-zA-Z\_]+/');
    }
  }